module.exports = __webpack_public_path__ + "static/media/md-alarm.054fbf09.svg";